var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"alert"}},[(_vm.show)?_c('div',{staticClass:"alert",attrs:{"placement":"top","type":_vm.type,"width":"400px"}},[_c('strong',[_c('icon',{attrs:{"name":"check"}}),_vm._v(_vm._s(_vm.title))],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-656c8952","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/explorer/alert.vue
// module id = mxtX
// module chunks = 1 2 3